import React from 'react';
import {
  JournalText,
  Calculator,
  FileEarmarkText,
  Image,
  CodeSlash,
  Search,
} from 'react-bootstrap-icons';

const CAPS = [
  {
    title: 'Homework help',
    body: 'Break down assignments into clear steps so you understand the why, not just the answer.',
    Icon: JournalText,
    tint: 'bg-brand-sky/15 text-brand-sky',
  },
  {
    title: 'Math with steps',
    body: 'Work through algebra, calculus, and word problems with guided explanations.',
    Icon: Calculator,
    tint: 'bg-brand-violet/15 text-brand-violet',
  },
  {
    title: 'Reading & documents',
    body: 'Upload a PDF or notes and get summaries, key points, and discussion prompts.',
    Icon: FileEarmarkText,
    tint: 'bg-brand-mint/15 text-brand-mint',
  },
  {
    title: 'Pictures & diagrams',
    body: 'Snap a worksheet photo or diagram and ask questions about what you see.',
    Icon: Image,
    tint: 'bg-brand-coral/15 text-brand-coral',
  },
  {
    title: 'Coding practice',
    body: 'Debug Scratch or Python, explain errors in plain language, and try safer rewrites.',
    Icon: CodeSlash,
    tint: 'bg-brand-amber/20 text-brand-amber',
  },
  {
    title: 'Research & study notes',
    body: 'Gather ideas for reports, compare sources, and turn topics into study outlines.',
    Icon: Search,
    tint: 'bg-brand-lime/20 text-brand-lime',
  },
];

export default function Capabilities() {
  return (
    <section id="capabilities" className="scroll-mt-24 bg-white py-14 sm:py-16">
      <div className="mx-auto max-w-landing px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-wide text-brand-navy">What it does</p>
          <h2 className="mt-2 font-display text-3xl font-extrabold text-brand-ink sm:text-4xl">
            Capabilities made for school
          </h2>
          <p className="mt-3 text-brand-muted">
            SchoolCracked is your always-on teaching assistant — ask anything about class, homework, or projects.
          </p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {CAPS.map(({ title, body, Icon, tint }) => (
            <div
              key={title}
              className="rounded-card border border-brand-line bg-brand-soft/60 p-5 shadow-brand-sm transition hover:-translate-y-0.5 hover:shadow-brand-md"
            >
              <div className={`mb-4 inline-flex h-11 w-11 items-center justify-center rounded-xl ${tint}`}>
                <Icon size={20} />
              </div>
              <h3 className="font-display text-lg font-bold text-brand-ink">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-muted">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
